import {Component, inject, LOCALE_ID, OnDestroy, OnInit} from '@angular/core';
import {MatExpansionModule} from '@angular/material/expansion';
import {NgForOf, NgIf} from '@angular/common';
import {Diskusia} from '../model/diskusia';
import {Subscription} from 'rxjs';
import {AppService} from '../app.service';

@Component({
    selector: 'app-podpora',
    imports: [
        MatExpansionModule,
        NgIf,
        NgForOf
    ],
    templateUrl: './podpora.component.html',
    styleUrl: './podpora.component.css'
})
export class PodporaComponent implements OnInit, OnDestroy
{
    data: Diskusia[];
    diskusiaData: Subscription;
    onDiskusiaClickSubscription: Subscription;
    show = false;

    protected locale =  inject(LOCALE_ID);

    constructor(
      private appService: AppService
    ) {
    }

    ngOnDestroy(): void {
        this.onDiskusiaClickSubscription.unsubscribe();
    }

    ngOnInit(): void {
      this.diskusiaData = this.appService.diskusiaData
        .subscribe((data: Diskusia[]) => {
          this.data = data;
        });
      this.onDiskusiaClickSubscription =
        this.appService.onDiskusiaClickSubject.subscribe(
          () => {
            this.show = !this.show;
          }
        );
    }

    protected getDiskusiaUrl(d: Diskusia) {
        return '/ais/apps/podpora/' + this.locale + /diskusia/ + d.id;
    }
}
